import {DrupalNode} from "next-drupal";

export function getKvpPair(node: DrupalNode, key: string, type?: string) {
  const fieldName = type === "long" ? "field_kvp_key_value_long" : "field_kvp_key_value_plain";
  if (node?.[fieldName] && key)
    for (const keyVal of node?.[fieldName]) {
      if (keyVal?.key === key) {
        return keyVal;
      }
    }
  return {};
}
